@import '../../../theme.scss';

verdocs-template-card {
  font-family: $primary-font;
  width: 320px;
  height: 320px;
  display: flex;
  padding: 25px;
  flex-wrap: nowrap;
  box-sizing: border-box;
  flex-direction: column;
  background-color: $verdocs-grey-4;
  box-shadow: 2px 2px 5px rgba(51, 54, 75, 0.05);

  .thumbnail {
    width: 272px;
    height: 158px;
    object-fit: cover;
    margin-bottom: 22px;
    object-position: -20% 0;
  }

  .name {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 7px;
  }

  .org-name {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 6px;
  }

  hr {
    width: 100%;
    margin-bottom: 17px;
    background-color: $icon-color;
  }

  .controls {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    text-align: center;
    font-size: 16px;

    .control {
      flex: 1;
      display: flex;
      margin-right: 8px;
      align-items: flex-start;
      border-right: 1px solid $icon-color;

      &.secondary {
        justify-content: center;
      }

      svg {
        fill: $icon-color;
        height: 16px;
        max-width: 16px;
        margin: 0 8px -2px 0;
      }
    }
  }

  .additional-controls svg {
    margin-right: 0;
    fill: $verdocs-purple;
  }
}
